module.exports = __webpack_public_path__ + "static/media/footer-bg-3-2.dbb4118e.svg";